// extracted by mini-css-extract-plugin
export default {"new-quote":"NewQuote_new-quote__q9Epe","form-group":"NewQuote_form-group__n2sxM","spinner":"NewQuote_spinner__l29Qh"};